import {
  useDeliveryInfo,
  useDeliveryPickup,
  usePickupInfo
} from '~/context/vdp/DeliveryPickupContext';
import useIsNotAvailableForImmediatePurchase from './useIsNotAvailableForImmediatePurchase';

// must return false in default loading state to ensure no layout shift
export default function useShouldHideDeliveryPickup() {
  const isNotPurchasable = useIsNotAvailableForImmediatePurchase();
  const { hasError, isLoaded } = useDeliveryPickup();
  const deliveryInfo = useDeliveryInfo();
  const pickupInfo = usePickupInfo();

  return (
    isNotPurchasable || hasError || (isLoaded && !deliveryInfo && !pickupInfo)
  );
}
